// Created by PeakXin on 2025/10/29.
const getters = {
  token: state => state.user.token,
  userInfo: state => state.user.userInfo,
  userName: state => state.user.userInfo.name,
  userId: state => state.user.userInfo.id
}

export default getters
